var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5269 0.00732422C10.8703 0.0414033 11.1933 0.193292 11.4395 0.439453L15.0605 4.06055C15.3418 4.3418 15.4999 4.72335 15.5 5.12109V16.5C15.5 17.2767 14.9096 17.9152 14.1531 17.9919L14 18H2C1.22326 18 0.584754 17.4096 0.508057 16.6531L0.5 16.5V1.5C0.5 0.671573 1.17157 3.62399e-08 2 0H10.3789L10.5269 0.00732422ZM2 16.5H14V5.12109L10.3789 1.5H2V16.5Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 4.5C10.6642 4.5 11 4.83579 11 5.25C11 5.66421 10.6642 6 10.25 6H4.25C3.83579 6 3.5 5.66421 3.5 5.25C3.5 4.83579 3.83579 4.5 4.25 4.5H10.25Z",
    fill: "#3F3F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 7.5C12.1642 7.5 12.5 7.83579 12.5 8.25C12.5 8.66421 12.1642 9 11.75 9H4.25C3.83579 9 3.5 8.66421 3.5 8.25C3.5 7.83579 3.83579 7.5 4.25 7.5H11.75Z",
    fill: "#3F3F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 10.5C12.1642 10.5 12.5 10.8358 12.5 11.25C12.5 11.6642 12.1642 12 11.75 12H4.25C3.83579 12 3.5 11.6642 3.5 11.25C3.5 10.8358 3.83579 10.5 4.25 10.5H11.75Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.e855c35091623109665929256117f0e8.svg";
export { ForwardRef as ReactComponent };